import { TOOLTIP_ARROW_PADDING } from '../constants/tooltipLayout';
import { ComputeTooltipPositionParams } from '../types/ComputeTooltipPositionParams';
import { TooltipPosition } from '../types/TooltipPosition';

const HALF = 0.5;

// Below the anchor unless only above fits, kept inside the viewport, with the
// arrow pointing at the anchor
export const computeTooltipPosition = ({
  anchor,
  arrowWidth,
  popper,
  viewport,
}: ComputeTooltipPositionParams): TooltipPosition => {
  const fitsBelow = anchor.bottom + popper.height <= viewport.height;
  const fitsAbove = anchor.top - popper.height >= 0;
  const anchorCenter = anchor.left + anchor.width * HALF;

  // Centred on the anchor, then shifted back inside the viewport, left edge first
  const maxLeft = Math.max(viewport.width - popper.width, 0);
  const left = Math.min(
    Math.max(anchorCenter - popper.width * HALF, 0),
    maxLeft,
  );

  const arrowLeft = Math.min(
    Math.max(anchorCenter - left - arrowWidth * HALF, TOOLTIP_ARROW_PADDING),
    popper.width - arrowWidth - TOOLTIP_ARROW_PADDING,
  );

  return {
    arrowLeft,
    left: left - anchor.left,
    placement: fitsBelow || !fitsAbove ? 'bottom' : 'top',
  };
};
